import React, {PureComponent} from "react";
import PropTypes from "prop-types";
import priceFormat from "../../../services/lib/price-format";

export default class SelectTemplate extends PureComponent {
  static propTypes = {
    variant: PropTypes.string.isRequired,
    title: PropTypes.string,
    items: PropTypes.array.isRequired,
    changeVariant: PropTypes.func,
    currentValue: PropTypes.string,
    dict: PropTypes.object,
    customHandleClick: PropTypes.func,
    priceMap: PropTypes.object
  };
  render() {
    const {
      variant,
      items,
      changeVariant,
      customHandleClick,
      currentValue,
      dict,
      priceMap,
      title
    } = this.props;
    return (
      <div className={`variant variant_${variant}`}>
        {title && <div className="variant__title">{title}</div>}
        <div className="variant__content b-input-field">
          <select
            value={currentValue}
            className="m-select browser-default"
            onChange={(e) => {
              const value = e.target.value;
              if (customHandleClick) {
                customHandleClick(e, variant, value);
              }
              changeVariant(e, variant, value);
            }}
          >
            {items.map((item) => {
              return (
                <option key={item} value={item}>
                  {dict[item]}
                  {priceMap &&
                    priceMap[item] &&
                    ` ${priceFormat(priceMap[item])}`}
                </option>
              );
            })}
          </select>
        </div>
      </div>
    );
  }
}
